import { useState } from "react";

const PenaliteSettings = ({ register, watch, setValue, unregister, errors }) => {
  const rates = watch("penalites_taux_legaux") || {};
  const keys = Object.keys(rates).sort().reverse();
  const latest = keys[0];
  const next = latest ? (latest.endsWith("S1") ? `${latest.slice(0, 4)}-S2` : `${Number(latest.slice(0, 4)) + 1}-S1`) : "2026-S2";
  const [period, setPeriod] = useState(null);
  const [error, setError] = useState("");
  const [showRates, setShowRates] = useState(false);
  return <div className="card space-y-4">
    <h2 className="text-lg font-semibold text-gray-900">Taux légaux pour les pénalités</h2>
    <p className="text-sm text-gray-600">
      Le calcul utilise le taux simple applicable à un créancier professionnel pour chaque semestre de retard,
      multiplié par le coefficient convenu sur la facture. Un semestre sans taux renseigné bloque la réclamation chiffrée.
    </p>
    <a href="https://www.service-public.gouv.fr/particuliers/vosdroits/F20688" target="_blank" rel="noreferrer"
      className="text-sm text-primary-700 hover:underline">Vérifier les taux sur Service Public</a>
    <details open={showRates} onToggle={(event) => setShowRates(event.currentTarget.open)}>
      <summary className="cursor-pointer text-sm text-primary-700">Consulter ou modifier les taux par semestre</summary>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-3">
        {keys.map((key) => <label key={key} className="text-sm text-gray-700">
          {key} (%)
          <input className="input-field mt-1" type="number" min="0" max="100" step="0.01"
            {...register(`penalites_taux_legaux.${key}`, { valueAsNumber: true, required: "Taux requis",
              min: { value: 0, message: "Taux positif requis" }, max: { value: 100, message: "Maximum 100 %" } })} />
          {errors.penalites_taux_legaux?.[key] && <span className="text-red-600">{errors.penalites_taux_legaux[key].message}</span>}
          <button type="button" aria-label={`Retirer le taux ${key}`} className="text-xs text-gray-500 hover:underline mt-1"
            onClick={() => unregister(`penalites_taux_legaux.${key}`)}>Retirer ce semestre</button>
        </label>)}
      </div>
    </details>
    <div className="flex flex-wrap items-end gap-3">
      <label className="text-sm text-gray-700">Nouveau semestre (YYYY-S1 ou YYYY-S2)
        <input className="input-field mt-1" value={period ?? next} onChange={(event) => setPeriod(event.target.value)} />
      </label>
      <button type="button" className="btn-secondary" onClick={() => {
        const key = period ?? next;
        if (!/^[0-9]{4}-S[12]$/.test(key) || Object.prototype.hasOwnProperty.call(rates, key)) {
          setError("Choisissez un semestre valide qui n'est pas déjà renseigné."); return;
        }
        setValue(`penalites_taux_legaux.${key}`, "");
        setShowRates(true);
        setPeriod(null); setError("");
      }}>Ajouter un semestre</button>
    </div>
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    <p className="text-xs text-gray-500">Renseignez le taux publié, puis sauvegardez les paramètres. Les taux initiaux couvrent 2015 à 2026.</p>
  </div>;
};

export default PenaliteSettings;
